const theme = {
    colors:{
        primary: '#151518',
        secondary: '#1C1B1B',
        white: '#fff',
        tertiary: '#68e0cf',
        background: '#121214',
        border: '#585d65'
    }
}

export default theme;